/* import __COLOCATED_TEMPLATE__ from './form.hbs'; */
import { classNames, tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './form.module.scss';

const CLIENT_TYPES = [
  { type: 'client', label: 'booking.clientType.me' },
  { type: 'couple', label: 'booking.clientType.couple' },
  { type: 'contact', label: 'booking.clientType.contact' },
];

const CLIENT_TYPES_FOR_CARE_COORDINATOR = [
  { type: 'client', label: 'booking.clientType.careCoordinator.member' },
  { type: 'couple', label: 'booking.clientType.careCoordinator.memberAndPartner' },
  { type: 'contact', label: 'booking.clientType.careCoordinator.memberOnBehalf' },
];

const ALLOWED_TO_BOOK = {
  'client,contact,couple': 'booking.clientType.messages.allTypes',
  'client,contact': 'booking.clientType.messages.clientContact',
  'client,couple': 'booking.clientType.messages.clientCouple',
  'contact,couple': 'booking.clientType.messages.contactCouple',
};

@classic
@tagName('form')
@classNames('client-type-form text-left', styles.component)
export default class RequestClientTypeForm extends Component {
  @service session;
  @service currentPractice;

  @computed('currentPractice.clientTypesAllowedToBookAppt')
  get enabledClientTypes() {
    return this.currentPractice.get('clientTypesAllowedToBookAppt');
  }

  @computed('enabledClientTypes.[]', 'model.channel')
  get clientTypeOptions() {
    let types = this.model.channel?.careCoordinatorMode
      ? CLIENT_TYPES_FOR_CARE_COORDINATOR
      : CLIENT_TYPES;
    return types.filter(clientType => this.enabledClientTypes.includes(clientType.type));
  }

  @computed('enabledClientTypes.[]', 'model.channel')
  get allowedToBookAppointmentMessage() {
    if (this.model.channel?.careCoordinatorMode) {
      return 'booking.clientType.messages.careCoordinator';
    } else {
      return ALLOWED_TO_BOOK[this.enabledClientTypes.sort().join(',')];
    }
  }
}
